// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__sJIOi","box":"WorkspacesBox_box__E0QCY","node":"WorkspacesBox_node__1T0F2"};